var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-dota2-footer"},[_vm._t("default"),_c('span',{staticClass:"footer-text"},[_vm._v("查看比赛详情")]),_c('hb-icon',{attrs:{"common-arrow-right-filled":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }